<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-3 pt-3 pr-3" style="height: 80vh;">
      <template>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="form.type"
              :items="type"
              label="Tipo"
              outlined
              :item-text="customText"
              item-value="id"
              clearable
              hide-details
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              ref="name"
              v-model="form.name"
              label="Nombre"
              outlined
              :rules="[() => !!form.name || 'Es necesario ingresar un nombre']"
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              ref="description"
              v-model="form.description"
              label="Descripcion"
              outlined
              :rules="[
                () =>
                  !!form.description || 'Es necesario ingresar una descripcion',
              ]"
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn block height="40" dark color="red" @click="handleCancel">
              <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              v-if="action == 'create'"
              dark
              color="success"
              block
              height="40"
              @click="handleStore"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Guardar
            </v-btn>
            <v-btn
              v-if="action == 'update'"
              dark
              color="success"
              block
              height="40"
              @click="handleUpdate"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from "vuex";
import { Array } from "../../helpers/Array";

export default {
  name: "CreateUpdate",
  data() {
    return {
      drawer: false,
      titleForm: null,
      action: null,
      form: {
        id: null,
        name: null,
        description: null,
        type: null,
      },
      type: Array.categoriaGastoType,
    };
  },
  methods: {
    ...mapActions("category-gasto", ["store", "update"]),
    async showForm(title, action, categoryGasto = null) {
      await this.clearData();
      this.titleForm = title;
      this.action = action;
      if (categoryGasto) {
        this.setArea(categoryGasto);
      }
      this.drawer = !this.drawer;
    },
    customText(item) {
      let text = item.name;

      return text;
    },
    clearData() {
      this.titleForm = null;
      this.action = null;
      this.form.id = null;
      this.form.name = null;
      this.form.description = null;
      this.form.type = null;

      this.clearErrors();
    },
    setArea(categoryGasto) {
      this.form.id = categoryGasto.id;
      this.form.name = categoryGasto.name;
      this.form.description = categoryGasto.description;
      this.form.type = categoryGasto.type;
    },
    closeForm() {
      this.clearData();
      this.drawer = false;
    },
    handleCancel() {
      this.closeForm();
    },
    async handleStore() {
      if (!this.existErrors()) {
        await this.store(this.form);
        this.closeForm();
      }
    },
    async handleUpdate() {
      if (!this.existErrors()) {
        await this.update(this.form);
        this.closeForm();
      }
    },
    existErrors() {
      let hasErrors = false;

      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.form[f]) hasErrors = true;
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    clearErrors() {
      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
  },
};
</script>

<style scoped></style>
